<template>
    <div>
        <div class="d-flex flex-column-fluid">
            <!--begin::Container-->
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <div
                                    class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  "
                                >
                                    <div
                                        class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    "
                                    >
                                        <div class="card-title mb-0">
                                            <h3
                                                class="card-label mb-0 font-weight-bold text-body"
                                            >
                                                Закупка
                                            </h3>
                                        </div>
                                        <button
                                            v-if="$route.params.id"
                                            type="button"
                                            class="btn"
                                            :class="[{'btn-dark': !processed}, {'btn-danger': processed}]"
                                            @click="switchProcess"
                                        >
                                            {{ processed ? 'Отменить проводку' : 'Провести' }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <div
                                    class="card card-custom gutter-b bg-white border-0"
                                >
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="text-body"
                                                    >Запросы</label
                                                    >
                                                    <fieldset
                                                        class="form-group mb-3"
                                                    >
                                                        <select
                                                            @change="
                                                                getQuotation()
                                                            "
                                                            v-model="
                                                                selectedQuotation
                                                            "
                                                            class="js-states form-control bg-transparent"
                                                        >
                                                            <option value=""
                                                            >Выбрать
                                                                запрос</option
                                                            >
                                                            <option
                                                                v-for="quotation in quotations"
                                                                v-bind:value="
                                                                    quotation.id
                                                                "
                                                            >
                                                                {{
                                                                    quotation.id
                                                                }}
                                                            </option>
                                                        </select>
                                                    </fieldset>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="text-body"
                                                    >Склад</label
                                                    >
                                                    <fieldset
                                                        class="form-group mb-3"
                                                    >
                                                        <select
                                                            v-model="
                                                                purchase.warehouse_id
                                                            "
                                                            class="js-states form-control bg-transparent"
                                                        >
                                                            <option value=""
                                                            >Выбрать
                                                                склад</option
                                                            >
                                                            <option
                                                                v-for="warehouse in warehouses"
                                                                v-bind:value="
                                                                    warehouse.warehouse_id
                                                                "
                                                            >
                                                                {{
                                                                    warehouse.warehouse_name
                                                                }}
                                                            </option>
                                                        </select>
                                                        <small
                                                            class="form-text text-danger"
                                                            v-if="
                                                                errors.has(
                                                                    'warehouse_id'
                                                                )
                                                            "
                                                            v-text="
                                                                errors.get(
                                                                    'warehouse_id'
                                                                )
                                                            "
                                                        ></small>
                                                    </fieldset>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="text-body"
                                                    >Поставщики</label
                                                    >
                                                    <fieldset
                                                        class="form-group mb-3"
                                                    >
                                                        <select
                                                            v-model="
                                                                purchase.supplier_id
                                                            "
                                                            class="js-states form-control bg-transparent"
                                                        >
                                                            <option value=""
                                                            >Выбрать
                                                                поставщиков</option
                                                            >
                                                            <option
                                                                v-for="supplier in suppliers"
                                                                v-bind:value="
                                                                    supplier.supplier_id
                                                                "
                                                            >
                                                                {{
                                                                    supplier.supplier_company_name
                                                                }}

                                                            </option>
                                                        </select>
                                                        <small
                                                            class="form-text text-danger"
                                                            v-if="
                                                                errors.has(
                                                                    'supplier_id'
                                                                )
                                                            "
                                                            v-text="
                                                                errors.get(
                                                                    'supplier_id'
                                                                )
                                                            "
                                                        ></small>
                                                    </fieldset>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="text-body"
                                                    >Дата закупки</label
                                                    >
                                                    <fieldset
                                                        class="form-group mb-3"
                                                    >
                                                        <input
                                                            type="date"
                                                            class="form-control bg-white"
                                                            value=""
                                                            v-model="
                                                                purchase.purchase_date
                                                            "
                                                        />
                                                    </fieldset>
                                                    <small
                                                        class="form-text text-danger"
                                                        v-if="
                                                            errors.has(
                                                                'purchase_date'
                                                            )
                                                        "
                                                        v-text="
                                                            errors.get(
                                                                'purchase_date'
                                                            )
                                                        "
                                                    ></small>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12">
                                <div
                                    class="card card-custom gutter-b bg-white border-0"
                                >
                                    <div class="card-body">
                                        <div class="col-md-12" style="padding: 0;">
                                            <label class="text-body"
                                            >Товары</label
                                            >
                                            <fieldset
                                                class="form-group mb-3 d-flex"
                                            >
                                                <multiselect
                                                    v-model="product_id"
                                                    :options="products"
                                                    :custom-label="nameWithLang"
                                                    placeholder="Выбрать товар"
                                                    label="name"
                                                    track-by="product_id"
                                                    :multiple="true"
                                                    :taggable="true"
                                                    @select="addProduct"
                                                    @remove="removeItem"
                                                    :show-labels="false"
                                                    :option-height="104"
                                                >
                                                    <template #tag="{ option, remove }">
                                                        <span class="multiselect__tag">
                                                            <span>{{ getOptionLabel(option)  }}</span>
                                                            <span class="custom__remove" @click="remove(option)"><i aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i></span>
                                                        </span>
                                                    </template>
                                                    <template #singleLabel="props">
                                                        <span class="option__desc">
                                                            <span class="option__title">{{ getOptionLabel(props.option)  }}</span>
                                                        </span>
                                                    </template>
                                                    <template #option="props">
                                                        <div class="option__desc"><span class="option__title">{{ getOptionLabel(props.option, true) }}</span></div>
                                                    </template>
                                                </multiselect>
                                            </fieldset>
                                            <small
                                                class="form-text text-danger"
                                                v-if="errors.has('product_id')"
                                                v-text="
                                                    errors.get('product_id')
                                                "
                                            ></small>
                                        </div>

                                        <div
                                            class="col-md-12"
                                            v-if="
                                                allCombinations.length
                                            "
                                        >
                                            <label class="text-body"
                                            >Выбрать товар с вариациями</label
                                            >
                                            <fieldset
                                                class="form-group mb-3 d-flex"
                                            >
                                                <multiselect
                                                    v-model="selectedCombinations"
                                                    :options="allCombinations"
                                                    placeholder="Выбрать товарс вариациями"
                                                    :custom-label="nameWithLangOld"
                                                    track-by="product_combination_id"
                                                    :multiple="true"
                                                    :taggable="true"
                                                    @select="addCombinationProduct"
                                                    @remove="removeItem"
                                                >
                                                </multiselect>
                                            </fieldset>
                                            <small
                                                class="form-text text-danger"
                                                v-if="errors.has('product_id')"
                                                v-text="
                                                    errors.get('product_id')
                                                "
                                            ></small>
                                        </div>
                                        <div
                                            class="col-12"
                                            style="padding: 0"
                                            v-if="productsInOrder.length"
                                        >
                                            <div class="table-responsive">
                                                <table
                                                    class="table table-striped text-body"
                                                >
                                                    <thead>
                                                    <tr>
                                                        <th
                                                            class="border-0 header-heading"
                                                            scope="col"
                                                        >
                                                            ID
                                                        </th>
                                                        <th
                                                            class="border-0 header-heading"
                                                            scope="col"
                                                        >
                                                            Название
                                                        </th>
                                                        <th
                                                            class="border-0 header-heading"
                                                            scope="col"
                                                        >
                                                            Остаток
                                                        </th>
                                                        <th
                                                            class="border-0 header-heading"
                                                            scope="col"
                                                        >
                                                            SKU
                                                        </th>
                                                        <th
                                                            class="border-0 header-heading"
                                                            scope="col"
                                                        >
                                                            Количество
                                                        </th>
                                                        <th
                                                            class="border-0 header-heading"
                                                            scope="col"
                                                        >
                                                            Скидка (%)
                                                        </th>
                                                        <th
                                                            class="border-0 header-heading"
                                                            scope="col"
                                                        >
                                                            Цена $
                                                        </th>
                                                        <th
                                                            class="border-0 header-heading"
                                                            scope="col"
                                                        >
                                                            Сумма $
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr
                                                        class=""
                                                        v-for="(selectedProduct, index) in productsInOrder"
                                                        :key="selectedProduct.product.product_combination_id ?  'c' + selectedProduct.product.product_combination_id : selectedProduct.product.product_id"
                                                    >
                                                        <td>
                                                            {{
                                                                index + 1
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                selectedProduct.product.title || selectedProduct.product.detail[0].title
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                (selectedProduct.product.available_qty)?selectedProduct.product.available_qty:0
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                (selectedProduct.product.product_combination_id)? selectedProduct.product.sku:selectedProduct.product.product_sku
                                                            }}
                                                        </td>
                                                        <td
                                                            class="text-center"
                                                        >
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                placeholder="Ввести количество"
                                                                v-model="selectedProduct.count"
                                                                @change="getTotalProduct()"
                                                            />
                                                            <small
                                                                class="form-text text-danger"
                                                                v-if="
                                                                        errors.has(
                                                                            'qty.' +
                                                                                index
                                                                        )
                                                                    "
                                                                v-text="
                                                                        errors.get(
                                                                            'qty.' +
                                                                                index
                                                                        )
                                                                    "
                                                            ></small>
                                                        </td>
                                                        <td
                                                            class="text-center"
                                                        >
                                                            <div class="input-group">
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    placeholder="Ввести скидку"
                                                                    v-model="selectedProduct.discount"
                                                                    @change="getTotalProduct()"
                                                                />
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">{{ currencySymbol }}</span>
                                                                </div>
                                                            </div>
                                                                <small
                                                                    class="form-text text-danger"
                                                                    v-if="
                                                                            errors.has(
                                                                                'price.' +
                                                                                    index
                                                                            )
                                                                        "
                                                                    v-text="
                                                                            errors.get(
                                                                                'price.' +
                                                                                    index
                                                                            )
                                                                        "
                                                                ></small>
                                                            </td>
                                                        <td
                                                            class="text-center"
                                                        >
                                                            <div class="input-group">
                                                                <input
                                                                    type="text"
                                                                    class="form-control"
                                                                    placeholder="Ввести цену"
                                                                    v-model="selectedProduct.price"
                                                                    @change="getTotalProduct()"
                                                                />
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">{{ currencySymbol }}</span>
                                                                </div>
                                                            </div>
                                                                <small
                                                                    class="form-text text-danger"
                                                                    v-if="
                                                                            errors.has(
                                                                                'price.' +
                                                                                    index
                                                                            )
                                                                        "
                                                                    v-text="
                                                                            errors.get(
                                                                                'price.' +
                                                                                    index
                                                                            )
                                                                        "
                                                                ></small>
                                                            </td>
                                                        <td
                                                            class="text-center"
                                                        >
                                                            <div class="input-group">
                                                                <input
                                                                    type="text"
                                                                    readonly
                                                                    class="form-control"
                                                                    placeholder="Ввести цену"
                                                                    :value="+(selectedProduct.count * +selectedProduct.price).toFixed(2)"
                                                                    @change="
                                                                            computeValues()
                                                                        "
                                                                />
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">{{ currencySymbol }}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td
                                                            class="text-right"
                                                        >
                                                            <span
                                                                href="#"
                                                                class="confirm-delete"
                                                                title="Delete"
                                                                @click="
                                                                        removeItem(index)
                                                                    "
                                                            ><i
                                                                class="fas fa-trash-alt"
                                                            ></i
                                                            ></span>
                                                        </td>

                                                        <input
                                                            type="hidden"
                                                            :set="
                                                                    (purchase.product_id[
                                                                        index
                                                                    ] =
                                                                        selectedProduct.product_id)
                                                                "
                                                        />
                                                        <input
                                                            type="hidden"
                                                            :set="
                                                                    (purchase.product_combination_id[
                                                                        index
                                                                    ] =
                                                                        selectedProduct.product_combination_id)
                                                                "
                                                        />
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            {{ productsCount }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            <small
                                                                class="form-text text-danger"
                                                                v-if="
                                                                        errors.has(
                                                                            'qty'
                                                                        )
                                                                    "
                                                                v-text="
                                                                        errors.get(
                                                                            'qty'
                                                                        )
                                                                    "
                                                            ></small>
                                                        </td>
                                                        <td colspan="3">
                                                            <small
                                                                class="form-text text-danger"
                                                                v-if="
                                                                        errors.has(
                                                                            'price'
                                                                        )
                                                                    "
                                                                v-text="
                                                                        errors.get(
                                                                            'price'
                                                                        )
                                                                    "
                                                            ></small>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12">
                                <div
                                    class="card card-custom gutter-b bg-white border-0"
                                >
                                    <div class="card-body">
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <label>Примечание</label>
                                                <fieldset
                                                    class="form-group mb-3"
                                                >
                                                    <textarea
                                                        class="form-control"
                                                        id="label-textarea"
                                                        rows="6"
                                                        name="notes"
                                                        placeholder="Добавьте примечание"
                                                        style="height: 130px"
                                                        spellcheck="false"
                                                        v-model="
                                                            purchase.description
                                                        "
                                                    ></textarea>
                                                </fieldset>
                                                <small
                                                    class="form-text text-danger"
                                                    v-if="
                                                        errors.has(
                                                            'description'
                                                        )
                                                    "
                                                    v-text="
                                                        errors.get(
                                                            'description'
                                                        )
                                                    "
                                                ></small>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end">
                                            <div class="col-12 col-md-3">
                                                <div>
                                                    <table
                                                        class="table right-table mb-0"
                                                    >
                                                        <tbody>
                                                        <tr
                                                            class="
                                  d-flex
                                  align-items-center
                                  justify-content-between
                                "
                                                        >
                                                            <th
                                                                class="border-0"
                                                            >
                                                                <h5
                                                                    class="
                                      font-size-h5
                                      mb-0
                                      font-size-bold
                                      text-dark
                                    "
                                                                >
                                                                    Сумма $
                                                                </h5>
                                                            </th>
                                                            <td
                                                                class="
                                    border-0
                                    justify-content-end
                                    d-flex
                                    text-black-50
                                    font-size-base
                                  "
                                                            >
                                                                {{
                                                                    totalAmount
                                                                }} $
                                                            </td>
                                                        </tr>

                                                        <!-- <tr
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <th class="border-0">
                              <h5
                                class="
                                  font-size-h5
                                  mb-0
                                  font-size-bold
                                  text-dark
                                "
                              >
                                Due Amount {{ getCurrencyTitle() }}
                              </h5>
                            </th>
                            <td
                              class="
                                border-0
                                justify-content-end
                                d-flex
                                text-black-50
                                font-size-base
                              "
                            >
                              {{ purchase.amount_due }}
                            </td>
                          </tr> -->
                                                        <!-- <tr
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <th class="border-0">
                              <h5
                                class="
                                  font-size-h5
                                  mb-0
                                  font-size-bold
                                  text-dark
                                "
                              >
                                Discount {{ getCurrencyTitle() }}
                              </h5>
                            </th>
                            <td
                              class="
                                border-0
                                justify-content-end
                                d-flex
                                text-black-50
                                font-size-base
                              "
                            >
                              <input
                                type="text"
                                class="form-control bg-white"
                                value="0"
                                v-model="purchase.discount_amount"
                                @change="computeValues()"
                              />
                              <small
                                class="form-text text-danger"
                                v-if="errors.has('discount_amount')"
                                v-text="errors.get('discount_amount')"
                              ></small>
                            </td>
                          </tr> -->
                                                        <!-- <tr
                            class="
                              d-flex
                              align-items-center
                              justify-content-between
                            "
                          >
                            <th class="border-0">
                              <h5
                                class="
                                  font-size-h5
                                  mb-0
                                  font-size-bold
                                  text-dark
                                "
                              >
                                Amount Paid {{ getCurrencyTitle() }}
                              </h5>
                            </th> -->
                                                        <!-- <td
                              class="
                                border-0
                                justify-content-end
                                d-flex
                                text-black-50
                                font-size-base
                              "
                            >
                              <input
                                type="text"
                                class="form-control bg-white"
                                value="0"
                                v-model="purchase.amount_paid"
                                @change="computeValues()"
                              />
                              <small
                                class="form-text text-danger"
                                v-if="errors.has('amount_paid')"
                                v-text="errors.get('amount_paid')"
                              ></small>
                            </td> -->
                                                        <!-- </tr> -->
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-if="!processed"
                                            class="col-md-12 d-flex justify-content-end"
                                            style="padding: 0"
                                        >
                                            <button
                                                class="btn btn-primary"
                                                @click="addPurchase()"
                                            >
                                                Подтвердить
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorHandling from "./../../ErrorHandling";
import Multiselect from "vue-multiselect";

export default {
    components: { Multiselect },
    data() {
        return {
            productsInOrder: [],
            allCombinations: [],
            allCombinationsWithTrash: [],
            productOrderInfo: { count: 1, price: '' },
            selectedCombinations: [],
            totalProduct: [],
            processed: false,

            display_form: 0,
            purchase: {
                supplier_id: "",
                purchase_date: new Date().toISOString().substr(0, 10),
                description: "",
                total_amount: 0,
                amount_paid: 0,
                discount_amount: 0,
                amount_due: 0,
                product_id: [],
                product_combination_id: [],
                price: [],
                qty: [],
                product_total: [],
                discount: [],
                warehouse_id: "",
                subTotal: 0
            },
            currency: [],
            product_id: [],
            combination_product_id: [],
            combination_products: [],
            customIndex: 0,
            display_table: false,
            searchParameter: "",
            sortBy: "id",
            sortType: "ASC",
            limit: 10,
            error_message: "",
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            purchases: [],
            warehouses: [],
            suppliers: [],
            products: [],
            selectedProducts: [],
            token: [],
            quotations: [],
            selectedQuotation: "",
            errors: new ErrorHandling(),
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content")
        };
    },
    computed:{
        currencySymbol() {
            return window.appConfig?.currencySymbol || '€';
        },
        totalAmount(){
            return (this.productsInOrder.reduce((prev, current) => { return prev + (+Number(current.price - (current.price * (current.discount / 100))).toFixed(2) * +current.count) }, 0)).toFixed(2)
        },
        productsCount(){
            return  this.productsInOrder.reduce((total, product) => {return total + Number(product.count);}, 0);
        }
    },
    methods: {
        fetchPurchase(id) {
            this.$parent.loading = true;
            this.errors = new ErrorHandling();
            this.$parent.loading = true;

            axios.get('/api/admin/purchase/' + id + '?getSupplier=1&getProductDetail=1&getProductCombinationDetail=1&getWarehouse=1', this.token)
                .then(async ({data}) => {
                    data = data.data;

                    //select from this.products which enabled in data.detail
                    this.product_id = data.detail.map(item => this.products.find(search => item.product.product_id === search.product_id))

                    for (let i = 0; i < this.product_id.length; i++) {
                        let productData = data.detail.find(search => search.product.product_id === this.product_id[i].product_id);
                        await this.addProductFromPurchase(this.product_id[i], productData)
                    }
                    this.addStartProducts(data.detail);
                    this.selectedCombinations = this.allCombinations.filter(item => data.detail.find(search => search.product_combination_id === item.product_combination_id))
                    this.getTotalProduct();
                    this.purchase.description = data.description;
                    this.purchase.supplier_id = data.supplier.supplier_id;
                    this.purchase.warehouse_id = data.warehouse.warehouse_id;
                    this.purchase.purchase_date = data.purchase_date;
                    this.processed = data.processed;
                    this.$parent.loading = false;
                })
                // .finally(() => (this.$parent.loading = false));
        },
        addStartProducts(products){
            products.forEach(item => {
                if(item.product_combination_id){
                    let p = this.allCombinations.find(search => search.product_combination_id === item.product_combination_id)
                    if(!p) {
                        p = this.allCombinationsWithTrash.find(search => search.product_combination_id === item.product_combination_id)
                        this.allCombinations.push(p);
                    }
                    this.productsInOrder.push({
                        product: p,
                        price: item.product_price,
                        count: item.product_qty,
                        discount: item.discount,
                    })

                } else {
                    let product = {
                        product: item.product,
                        ...this.productOrderInfo,
                        price: item.product_price,
                        count: item.product_qty,
                        discount: item.discount,
                    }
                    this.productsInOrder.push(product);
                }
            })
        },
        fetchPurchaseQuotations() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios
                .get("/api/admin/quotation?type=purchase", config)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.quotations = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        switchProcess(){
            this.$parent.loading = true;
            const token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };

            axios
                .post(`/api/admin/purchase/${this.$route.params.id}/${this.processed ? 'unprocess' : 'process'}`, {}, this.token)
                .then(res => {
                    this.processed = !this.processed;
                    this.$toaster.success(res.data.message);
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCurrency() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios
                .get("/api/admin/currency?is_default=1", config)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.currency = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchWarehouses() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios
                .get("/api/admin/warehouse?getAllData=1", config)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.warehouses = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchProducts() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios
                .get("/api/admin/product?getAllData=1", config)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.products = res.data.data;
                    }
                    if(this.$route.params.id){
                        this.fetchPurchase(this.$route.params.id);
                    }
                })
                .finally(() => (this.$parent.loading = false));


        },
        fetchSuppliers() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios
                .get("/api/admin/supplier?getAllData=1", config)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.suppliers = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        getTotalProduct(){
            this.productsInOrder.forEach((item, i) => {
                this.totalProduct[i] = (item.count * item.price).toFixed(2);
            })
        },

        addPurchase() {
            this.$parent.loading = true;
            let url = "/api/admin/purchase";
            if (this.$route.params.id) {
                // Update
                url = "/api/admin/purchase/" + this.$route.params.id;
                this.request_method = "put";
            } else {
                // Add
                this.request_method = "post";
            }
            //this.productsInOrder.reduce((prev, current) => { return prev + (+current.price * +current.count) }, 0);
            let total_amount = this.totalAmount;
            const data = {
                supplier_id: this.purchase.supplier_id,
                purchase_date: this.purchase.purchase_date,
                description: this.purchase.description,
                total_amount: total_amount,
                warehouse_id: this.purchase.warehouse_id,
                product_id: this.productsInOrder.map(item => item.product.product_id),
                product_combination_id: this.productsInOrder.map(item => item.product.product_combination_id ? item.product.product_combination_id : null),
                price: this.productsInOrder.map(item => item.price),
                qty: this.productsInOrder.map(item => item.count),
                discount: this.productsInOrder.map(item => item.discount),
                amount_paid: 0,
                discount_amount: 0,
                amount_due: total_amount - 0,
                product_total: this.totalProduct
            }

            axios[this.request_method](url, data, this.token)
                .then(res => {
                    if (res.data.status == "Success") {
                        if (!this.$route.params.id) {
                            this.clearForm();
                        }
                        this.$toaster.success(res.data.message);
                        if (res.data.purchase_id) {
                            this.$router.push(`/admin/purchase-detail/${res.data.purchase_id}`);
                        }

                        // this.$router.push("/admin/purchases");
                    } else {
                        this.$toaster.error(res.data.message);
                    }
                })
                .catch(error => {
                    this.error_message = "";
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if (error.response.data.status == "Error") {
                            this.$toaster.error(error.response.data.message);
                        } else {
                            this.errors.record(error.response.data.errors);
                        }
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },

        incrementIndex() {
            console.log("custom index => ");
            // this.customIndex++;
        },
        computeValues: function() {
            if (this.purchase.qty.length == this.purchase.price.length) {
                let subTotal = 0;
                for (var i = 0; i < this.purchase.qty.length; i++) {
                    if (
                        this.purchase.qty[i] != "" &&
                        this.purchase.price[i] != "" &&
                        !isNaN(this.purchase.qty[i]) &&
                        !isNaN(this.purchase.price[i])
                    ) {
                        subTotal =
                            subTotal +
                            this.purchase.qty[i] * this.purchase.price[i];
                        this.purchase.product_total.push(
                            this.purchase.qty[i] * this.purchase.price[i]
                        );
                    } else {
                        subTotal = subTotal + 0;
                        this.purchase.product_total.push(0);
                    }
                }
                this.purchase.total_amount =
                    subTotal - this.purchase.discount_amount;
                this.purchase.amount_due =
                    this.purchase.total_amount - this.purchase.amount_paid;
            }
        },
        getCurrencyTitle() {
            return this.currency == null ? "" : "(" + this.currency.title + ")";
        },
        getQuotation() {
            if (this.selectedQuotation == "") {
                this.clearForm();
                return;
            }
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios
                .get(
                    "/api/admin/quotation/" +
                    this.selectedQuotation +
                    "?getWarehouse=1&getTax=1&getQuotationDetail=1&productDetail=1&getCustomer=1",
                    config
                )
                .then(res => {
                    if (res.data.status == "Success") {
                        this.purchase.warehouse_id = res.data.data.warehouse
                            ? res.data.data.warehouse.warehouse_id
                            : "";
                        // this.purchase.customer_id = res.data.data.customer.customer_id;
                        for (
                            var i = 0;
                            i < res.data.data.quotationDetail.length;
                            i++
                        ) {
                            var quotationDetail =
                                res.data.data.quotationDetail[i];
                            this.product_id.push({
                                product_id: quotationDetail.product.product_id,
                                detail: quotationDetail.product.detail
                            });
                            this.addProduct(
                                {
                                    product_id:
                                    quotationDetail.product.product_id
                                },
                                quotationDetail.product.product_id,
                                quotationDetail
                            );

                            if (
                                quotationDetail.product.product_type ==
                                "variable"
                            ) {
                                var combination_detail =
                                    quotationDetail.product.combination_detail;
                                var product = quotationDetail.product;
                                if (combination_detail.length > 0) {
                                    var arr = {};
                                    for (
                                        var i = 0;
                                        i < combination_detail.length;
                                        i++
                                    ) {
                                        if (
                                            quotationDetail.product_combination_id ==
                                            combination_detail[i]
                                                .product_combination_id
                                        ) {
                                            arr.product_price =
                                                combination_detail[i].price;

                                            arr.product_combination_id =
                                                combination_detail[
                                                    i
                                                    ].product_combination_id;
                                            var combination_name = "";
                                            if (
                                                combination_detail[i]
                                                    .combination.length > 0
                                            ) {
                                                for (
                                                    var j = 0;
                                                    j <
                                                    combination_detail[i]
                                                        .combination.length;
                                                    j++
                                                ) {
                                                    if (j == 0) {
                                                        combination_name =
                                                            combination_detail[
                                                                i
                                                                ].combination[j]
                                                                .variation
                                                                .detail[0].name;
                                                    } else {
                                                        combination_name +=
                                                            "-" +
                                                            combination_detail[
                                                                i
                                                                ].combination[j]
                                                                .variation
                                                                .detail[0].name;
                                                    }
                                                    // console.log('i=' + i + 'j=' + j);
                                                }
                                            }

                                            arr.product_id = product.product_id;
                                            arr.product_type =
                                                product.product_type;
                                            arr.qty = "";
                                            arr.stock_status = "";
                                            arr.warehouse = "";
                                            arr.product_price =
                                                combination_detail[i].price;

                                            arr.title =
                                                product.detail.length > 0
                                                    ? product.detail[0].title +
                                                    " (" +
                                                    combination_name +
                                                    ")"
                                                    : "";

                                            this.addCombinationProduct(
                                                arr,
                                                arr.product_combination_id,
                                                quotationDetail
                                            );
                                            this.combination_product_id.push({
                                                qty: "",
                                                stock_status: "",
                                                warehouse: "",
                                                product_id: arr.product_id,
                                                product_combination_id:
                                                arr.product_combination_id,
                                                title: arr.title,
                                                product_type: "variable",
                                                product_price: arr.product_price
                                            });

                                            arr = {};
                                        }
                                    }
                                }
                            }
                        }

                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        clearForm() {
            this.productsInOrder = [];
            this.selectedCombinations = [];

            this.display_form = 0;
            this.display_table = false;
            this.product_id = [];
            this.combination_product_id = [];
            this.combination_products = [];
            this.selectedQuotation = "";
            this.purchase = {
                supplier_id: "",
                purchase_date: new Date().toISOString().substr(0, 10),
                description: "",
                total_amount: 0,
                amount_paid: 0,
                discount_amount: 0,
                amount_due: 0,
                product_id: [],
                product_combination_id: [],
                price: [],
                qty: [],
                product_total: [],
                discount: [],
                warehouse_id: "",
                subTotal: 0
            };
            this.errors = new ErrorHandling();
            this.selectedProducts = [];
        },
        async addProduct(selectedOption, id, quotationDetail = {}) {
            this.errors = new ErrorHandling();
            this.$parent.loading = true;
            const token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            await axios
                .get(
                    "/api/admin/product/" +
                    selectedOption.product_id +
                    "?getDetailWithLanguage=1&getDetail=1",
                    config
                )
                .then(({data}) => {
                    if (data.data.product_type === "simple") {
                        this.productsInOrder.push({
                                product: data.data,
                                ...this.productOrderInfo,
                                discount: 0,
                       });
                    }
                    if (data.data.product_type !== "simple" && data.data.combination_detail.length > 0) {
                        data.data.combination_detail.forEach((combination) => {
                                let combination_name = combination.combination.map(item => item.variation.detail[0].name);
                                combination.title = data.data.detail.length ? `${data.data.detail[0].title} (${combination_name.join('-')})` : '';
                                this.allCombinations.push(combination);
                        })
                    }
                })
                .finally(() => {
                    this.computeValues();
                    this.$parent.loading = false

                });
        },
        async addProductFromPurchase(selectedOption, productData) {
            if (productData.product.product_type !== "simple" && productData.product.combination_detail.length > 0) {

                productData.product.combination_detail.forEach((combination) => {
                    let p = this.allCombinations.find(search => search.product_combination_id === combination.product_combination_id)
                    if(!p) {
                        if(combination.deleted<1) {
                            let combination_name = combination.combination.map(item => item.variation.detail[0].name);
                            combination.title = productData.product.detail.length ? `${productData.product.detail[0].title} (${combination_name.join('-')})` : '';
                            this.allCombinations.push(combination);
                        } else {
                            let combination_name = combination.combination.map(item => item.variation.detail[0].name);
                            combination.title = productData.product.detail.length ? `${productData.product.detail[0].title} (${combination_name.join('-')})` : '';
                            this.allCombinationsWithTrash.push(combination);
                        }
                    }
                })
            }
            this.computeValues();

            // this.errors = new ErrorHandling();
            // this.$parent.loading = true;
            // const token = localStorage.getItem("token");
            // const config = {
            //     headers: {
            //         Authorization: `Bearer ${token}`
            //     }
            // };
            // await axios
            //     .get(
            //         "/api/admin/product/" +
            //         selectedOption.product_id +
            //         "?getDetailWithLanguage=1&getDetail=1&getWithTrash=1&shortData=1",
            //         config
            //     )
            //     .then(({data}) => {
            //         let input = productData.product;
            //         let input2 = data.data;
            //
            //         // debugger;
            //
            //         if (productData.product.product_type !== "simple" && productData.product.combination_detail.length > 0) {
            //             productData.product.combination_detail.forEach((combination) => {
            //                 let p = this.allCombinations.find(search => search.product_combination_id === combination.product_combination_id)
            //                 if(!p) {
            //                     if(combination.deleted<1) {
            //                         let combination_name = combination.combination.map(item => item.variation.detail[0].name);
            //                         combination.title = productData.product.detail.length ? `${productData.product.detail[0].title} (${combination_name.join('-')})` : '';
            //                         this.allCombinations.push(combination);
            //                     } else {
            //                         let combination_name = combination.combination.map(item => item.variation.detail[0].name);
            //                         combination.title = productData.product.detail.length ? `${productData.product.detail[0].title} (${combination_name.join('-')})` : '';
            //                         this.allCombinationsWithTrash.push(combination);
            //                     }
            //                 }
            //             })
            //         }
            //     })
            //     .finally(() => {
            //         this.computeValues();
            //         this.$parent.loading = false
            //     });
        },
        addCombinationProduct(selectedOption, id,quotationDetail={}) {
            this.productsInOrder.push({
                product: selectedOption,
                ...this.productOrderInfo,
                count: 0,
                discount: 0,
            })
            // console.log(selectedOption, id, quotationDetail )
            // this.selectedProducts.push(selectedOption);
            // this.purchase.qty.push(
            //     quotationDetail.hasOwnProperty("qty") ?parseInt( quotationDetail.qty) : 1
            // );
            // this.purchase.price.push(
            //     quotationDetail.hasOwnProperty("qty")
            //         ? quotationDetail.price
            //         : ""
            // );
            //  this.computeValues();
        },
        removeItem(removedOption, id) {
            console.log(removedOption)
            if(typeof removedOption === 'object'){
                this.productsInOrder = this.productsInOrder.filter(item => {
                    return removedOption.product_combination_id
                        ? item.product.product_combination_id !== removedOption.product_combination_id
                        : item.product.product_id !== removedOption.product_id
                });
                this.allCombinations = this.allCombinations.filter(item => item.product_id !== removedOption.product_id)
                this.selectedCombinations = this.selectedCombinations.filter(item => item.product_id !== removedOption.product_id)
            } else {
                let deleted = this.productsInOrder.splice(removedOption, 1)[0];
                if(deleted.product.product_combination_id) {
                    this.selectedCombinations = this.selectedCombinations.filter(item => item.product_combination_id !== deleted.product.product_combination_id)
                } else {
                    this.product_id = this.product_id.filter(item => item.product_id !== deleted.product.product_id)
                }
            }

            // console.log(removedOption);
            // // check if key exists
            // const hasKey = "product_combination_id" in removedOption;
            // if (hasKey) {
            //     if (
            //         removedOption.product_combination_id != null &&
            //         removedOption.product_combination_id != ""
            //     ) {
            //         this.selectedProducts.forEach((el, index) => {
            //             if (
            //                 el.product_combination_id ==
            //                 removedOption.product_combination_id
            //             ) {
            //                 this.selectedProducts.splice(index, 1);
            //                 this.purchase.qty.splice(index, 1);
            //                 this.purchase.product_combination_id.splice(
            //                     index,
            //                     1
            //                 );
            //                 this.purchase.product_id.splice(index, 1);
            //             }
            //         });
            //
            //         this.combination_product_id = this.combination_product_id.filter(
            //             function(el) {
            //                 return (
            //                     el.product_id != removedOption.product_id &&
            //                     el.product_combination_id !=
            //                         removedOption.product_combination_id
            //                 );
            //             }
            //         );
            //     }
            // } else {
            //     this.selectedProducts.forEach((el, index) => {
            //         if (el.product_id == removedOption.product_id) {
            //             this.selectedProducts.splice(index, 1);
            //             this.purchase.qty.splice(index, 1);
            //             this.purchase.product_combination_id.splice(index, 1);
            //             this.purchase.product_id.splice(index, 1);
            //         }
            //     });
            //
            //     this.combination_product = this.combination_products.filter(
            //         function(el) {
            //             return el.product_id != removedOption.product_id;
            //         }
            //     );
            // }
            // // this.selectedProducts.splice(index, 1);
            // // this.stock.qty.splice(index, 1);
        },
        getOptionLabel(option, skus = false) {
            let label = option.label || option.title || (Array.isArray(option.detail) && option.detail[0]?.title) || '';

            let skuData = [];

            if (option.product_sku) {
                skuData.push(option.product_sku);
            }

            if (skus && option.product_skus) {
                if (Array.isArray(option.product_skus)) {
                    skuData.push(...option.product_skus);
                } else {
                    skuData.push(option.product_skus);
                }
            }

            if (skuData.length > 0) {
                label += ` - (${skuData.join(", ")})`;
            }

            return label;
        },


        nameWithLang(option) {
            let name = (option.product_combination_id) ? option.title : option.detail[0].title;

            let data = [];

            if (option.product_sku) {
                data.push(option.product_sku);
            }

            if (option.product_barcodes) {
                data.push(option.product_barcodes.trim().replace(/^,|,$/g, ''));
            }

            if (option.product_skus) {
                if (Array.isArray(option.product_skus)) {
                    data.push(...option.product_skus);
                } else {
                    //data.push(option.sku);
                }
            }

            if (data.length > 0) {
                name += " - (" + data.join(", ") + ")";
            }

            return name;
        },

        nameWithLangOld(option) {
            let name = (option.product_combination_id)?option.title:option.detail[0].title;
            if(option.product_ean) {
                name += " - "+option.product_ean;
            }
            if(option.product_barcodes) {
                name += " - "+option.product_barcodes;
            }
            if(option.product_barcodes && option.product_barcode != option.product_ean) {
                // name += " - "+option.product_barcodes;
            }
            if(option.product_sku && option.product_sku != option.product_ean) {
                name += " - "+option.product_sku;
            }
            if(option.sku) {
                name += " - "+option.sku;
            }

            return name;
        },

    },
    mounted() {
        var token = localStorage.getItem("token");
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        this.fetchPurchaseQuotations();
        this.fetchCurrency();
        this.fetchWarehouses();
        this.fetchSuppliers();
        this.fetchProducts();

        // if(this.$route.params.id){
        //     this.fetchPurchase(this.$route.params.id);
        // }
    }
};
</script>
